import { createRoute } from "@tanstack/react-router"

import { withGlobalLoader } from "@/lib/context.ts"
import { InvitationScene } from "@/routes/invitations/InvitationScene.tsx"
import { InvitationViewModel } from "@/routes/invitations/InvitationViewModel.ts"
import { ReservedRoute } from "@/routes/root/RootRoute.tsx"

export const InvitationRoute = createRoute({
  path: "/invite",
  component: () => <InvitationScene />,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      token: search.token as string,
      orgId: search.orgId as string
    }
  },
  beforeLoad: ({ search }) => {
    if (!search.token || typeof search.token !== "string") {
      throw new Error("Invalid invitation token")
    }
    if (!search.orgId || typeof search.orgId !== "string") {
      throw new Error("Invalid organization ID")
    }
  },
  loaderDeps: ({ search }) => {
    return {
      token: search.token as string,
      orgId: search.orgId as string,
    }
  },
  loader: async ({ deps, context }) => {
    const model = new InvitationViewModel(deps.token, deps.orgId, context.buildLocation)
    await withGlobalLoader(context, model.awaitReady())
    return { model }
  },
  getParentRoute: () => ReservedRoute,
})